/* eslint-disable arrow-parens */
/* eslint-disable comma-dangle */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import AceEditor from 'react-ace';

import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-dracula';

import { Container } from './styles';
import api from '~/services/api';
import history from '~/services/history';

export default function Feedback() {
  const [scorecard, setScorecard] = useState('');
  const [challenge, setChallenge] = useState('');
  const [newAnswer, setNewAnser] = useState('');
  const [code, setCode] = useState('');
  const { id } = useParams();

  useEffect(() => {
    async function getData() {
      const { data } = await api.get(`scorecards/${id}`);

      setScorecard(data);
      setChallenge(data.challenge);
    }

    getData();
  }, [id]);

  function onLoad() {}

  function onChangeCode(newValue) {
    setCode(newValue);
  }

  const handleInputChange = (e) => {
    const { value } = e.target;
    setNewAnser(value);
  };

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (newAnswer.length >= 1) {
        await api.put(`challenges/${id}/scorecards`, {
          link_answer: newAnswer,
        });
        return toast.success('Resposta enviada com sucesso', {
          onClose: () => history.push('/scorecard'),
        });
      }
      return toast.error('Preencha o campo de resposta e tente novamente.');
    } catch (error) {
      return toast.error('Desafio já enviado, veja sua página de desafios.');
    }
  }

  async function handleSubmitCode(e) {
    e.preventDefault();

    try {
      if (code.length > 5) {
        await api.put(`challenges/${id}/scorecards`, {
          code_answer: code,
        });
        return toast.success('Resposta enviada com sucesso', {
          onClose: () => history.push('/scorecard'),
        });
      }
      return toast.error('Preencha o campo de resposta e tente novamente.');
    } catch (error) {
      return toast.error('Desafio já enviado, veja sua página de desafios.');
    }
  }

  return (
    <>
      <p
        style={{
          fontSize: 26,
          paddingLeft: 40,
          paddingTop: 30,
          color: '#36DED6',
          fontWeight: 'bold',
        }}
      >
        Corrigir Desafio
      </p>
      <Container>
        <p>Desafio: {challenge.title}</p>
        <p>Pergunta: {challenge.question}</p>
        {/* {challenge.description ? (
          <p>Descriçāo: {challenge.description}</p>
        ) : null}
        {challenge.link_question ? (
          <p>Link: {challenge.link_question}</p>
        ) : null} */}

        <div className="answer">
          <h1>Sua Resposta:</h1>
          {challenge.type === 'code' ? (
            <AceEditor
              placeholder="Placeholder Text"
              mode={`${challenge.language}`}
              theme="dracula"
              name="blah2"
              fontSize={14}
              showPrintMargin
              showGutter
              highlightActiveLine
              value={
                scorecard.code_answer === null
                  ? 'Nāo foi possível carregar o script.'
                  : scorecard.code_answer
              }
              width="800px"
              height="300px"
            />
          ) : (
            <p>{scorecard.link_answer}</p>
          )}
        </div>

        <div className="feedback">
          <h1>Feedback:</h1>
          <p>{scorecard.feedback}</p>
        </div>

        <div className="form">
          <h1>Enviar nova resposta:</h1>
          <form action="submit">
            {challenge.type === 'code' ? (
              <>
                <AceEditor
                  placeholder="Placeholder Text"
                  mode={`${challenge.language}`}
                  theme="dracula"
                  name="blah2"
                  onLoad={onLoad}
                  onChange={onChangeCode}
                  fontSize={14}
                  showPrintMargin
                  showGutter
                  highlightActiveLine
                  value={code}
                  width="800px"
                  height="400px"
                  setOptions={{
                    enableBasicAutocompletion: true,
                    enableLiveAutocompletion: true,
                    enableSnippets: true,
                    showLineNumbers: true,
                    tabSize: 2,
                  }}
                />
                <button
                  className="submitCode"
                  type="submit"
                  onClick={(e) => handleSubmitCode(e)}
                >
                  ENVIAR
                </button>
              </>
            ) : (
              <>
                <textarea
                  type="text"
                  placeholder="Reenviar resposta"
                  value={newAnswer}
                  onChange={handleInputChange}
                />
                <button
                  className="submitAnswer"
                  type="submit"
                  onClick={(e) => handleSubmit(e)}
                >
                  ENVIAR
                </button>
              </>
            )}
          </form>
        </div>
      </Container>
    </>
  );
}
